/**
 * @type {RegExp} Wyrazenie regularne do parsowania aliasu produktu i opcjonalnego identyfikatora jego szablonu albo parametrów.
 */
export const ALIAS_REGEX: RegExp =
  /([a-zA-Z0-9_-]+)(?:\((.*)\))?(?:\.([a-zA-Z0-9_-]+))?/
